import { render, staticRenderFns } from "./pickUpCarInfoDetail.vue?vue&type=template&id=8cd80078&scoped=true&"
import script from "./pickUpCarInfoDetail.vue?vue&type=script&lang=js&"
export * from "./pickUpCarInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./pickUpCarInfoDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd80078",
  null
  
)

export default component.exports